/**
 * Unsubscribe Emails Route - React Router v7
 *
 * Route: /cancelar-suscripcion-emails
 * Description: Unsubscribe from email notifications and manage email preferences
 * Note: This page doesn't have getInitialProps (client-side only)
 */
/* eslint-disable @typescript-eslint/restrict-template-expressions, @typescript-eslint/no-throw-literal, @typescript-eslint/strict-boolean-expressions, @typescript-eslint/prefer-nullish-coalescing, @typescript-eslint/no-unused-vars */
import type {LoaderFunctionArgs} from 'react-router-dom'
import {useLoaderData} from 'react-router-dom'

import UserUnsubscribeEmails from './index.js'

// Import styles
import './index.scss'

/**
 * Loader for Unsubscribe Emails
 * This page is mostly client-side, loader just returns empty data
 */
export async function loader({context, request}: LoaderFunctionArgs) {
  // This page handles everything client-side
  // No server data fetching needed
  return {}
}

/**
 * Component wrapper
 * Uses existing UserUnsubscribeEmails component
 */
export function Component() {
  const data = useLoaderData()
  return <UserUnsubscribeEmails {...data} />
}

export default {loader, Component}
